(function () {
	angular.module('ShargoApp')
		.controller('ClientsPageController', function ($scope, $rootScope, Configuration) {
			$rootScope.pageConfiguration = {
				footer: true,
				header: {
					solid: $rootScope.device.isDesktop ? 525 : 560,
					background: 'linear-gradient(to bottom, #fed256, #ffbd4d)',
					preheader: false,
					headerLink: $rootScope.url('home'),
					headerLogo: $rootScope.device.isDesktop ? Configuration.siteDomain + "/img/header/shargo-white.svg" : Configuration.siteDomain + "/img/header/shargo-mobile.svg",
					logIn: false,
					dashboard: false,
					callToAction: {
						link: $rootScope.url('contact'),
						text: 'header.contact',
						target: '',
						hide: !$rootScope.device.isDesktop,
						disabled: false
					},
					profile: false
				}
			};

			/*  --VARIABLES--  */
			$scope.showHistories = true;
			$scope.clientsPages = [
				{
					name: "Nostrum",
					url: Configuration.siteDomain
				},
				{
					name: "Òptica Universitaria",
					url: Configuration.siteDomain
				},
				{
					name: "Brava Fabrics",
					url: Configuration.siteDomain
				},
				{
					name: "Camper",
					url: Configuration.siteDomain
				},
				{
					name: "Bossvi",
					url: Configuration.siteDomain
				},
				{
					name: "Media Market",
					url: Configuration.siteDomain
				}
			];

			$scope.clientsInfo = [];
			for (var i = 0; i < 4; ++i) {
				var client = {
					title: "clients.page.principal.client" + 0 + ".title",
					subtitle: "clients.page.principal.client" + 0 + ".subtitle",
					info: "clients.page.principal.client" + 0 + ".info",
					url: "clients.page.principal.client" + 0 + ".url",
					style: {'background-image': 'url(' + Configuration.siteDomain + '/img/clients/clients' + 0 + '.jpg)'}
				};
				$scope.clientsInfo.push(client);
			}

			$scope.clientsLandscape = [];
			for (var i = 0; i < 2; ++i) {
				var client = {
					title: "clients.page.principal.client" + 0 + ".title",
					subtitle: "clients.page.principal.client" + 0 + ".subtitle",
					info: "clients.page.principal.client" + 0 + ".info",
					url: "clients.page.principal.client" + 0 + ".url",
					style: {'background-image': 'url(' + Configuration.siteDomain + '/img/clients/clients' + 0 + '.jpg)'}
				};
				$scope.clientsLandscape.push(client);
			}

			$scope.clientsCards = [];
			var clients = [];
			for (var i = 0; i < 6; ++i) {
				var client = {
					title: "clients.page.principal.client" + 0 + ".subtitle",
					subtitle: "clients.page.principal.client" + 0 + ".subtitle",
					info: "clients.page.principal.client" + 0 + ".info",
					url: "clients.page.principal.client" + 0 + ".url",
					style: {'background-image': 'url(' + Configuration.siteDomain + '/img/clients/clients' + 0 + '.jpg)'}
				};
				clients.push(client);
				if (clients.length === 3 || i === 6 - 1) {
					$scope.clientsCards.push(clients);
					clients = [];
				}
			}

			/*  --FUNCTIONS-- */
			function goDown() {
				if ($rootScope.device.isDesktop) {
					angular.element("body").animate({scrollTop: 525}, "slow");
				}
				else {
					angular.element("body").animate({scrollTop: 560}, "slow");
				}
			}

			function expandHistories() {
				for (var i = 0; i < 4; ++i) {
					var client = {
						title: "clients.page.principal.client" + 0 + ".title",
						subtitle: "clients.page.principal.client" + 0 + ".subtitle",
						info: "clients.page.principal.client" + 0 + ".info",
						url: "clients.page.principal.client" + 0 + ".url",
						style: {'background-image': 'url(' + Configuration.siteDomain + '/img/clients/clients' + 0 + '.jpg)'}
					};
					$scope.clientsInfo.push(client);
				}

				var clients;
				for (var i = 0; i < 4; ++i) {
					if (i === 0 && $scope.clientsCards[$scope.clientsCards.length - 1].length < 3) {
						clients = $scope.clientsCards[$scope.clientsCards.length - 1];
						$scope.clientsCards.splice($scope.clientsCards.length - 1, 1);
					}
					else if (i === 0) {
						clients = [];
					}
					var client = {
						title: "clients.page.principal.client" + 0 + ".subtitle",
						subtitle: "clients.page.principal.client" + 0 + ".subtitle",
						info: "clients.page.principal.client" + 0 + ".info",
						url: "clients.page.principal.client" + 0 + ".url",
						style: {'background-image': 'url(' + Configuration.siteDomain + '/img/clients/clients' + 0 + '.jpg)'}
					};
					clients.push(client);
					if (clients.length === 3 || i === 4 - 1) {
						$scope.clientsCards.push(clients);
						clients = [];
					}
				}

				$scope.showHistories = false;
			}

			/*  --EXECUTION--  */
			$scope.goDown = goDown;
			$scope.expandHistories = expandHistories;
	})
})();